<template>
  <div class="eligibility-tags">
    <el-popover
        v-for="name in services"
        :key="name"
        placement="left"
        trigger="hover">
      <template>
        <EligibilityReasons
            :reasons="eligibility[name].ineligibilityReasons || []"
            :service="name" />
        <el-tag
            slot="reference"
            size="mini"
            :type="tagTypeFor(name)"
            style="margin-right: 3px; margin-bottom: 3px; cursor: help">
          {{ name }}
        </el-tag>
      </template>
    </el-popover>
  </div>
</template>

<script>
import EligibilityReasons from "@/components/Shared/EligibilityReasons.vue";

export default {
  name: "EligibilityTags",

  components: {
    EligibilityReasons,
  },

  props: {
    eligibility: {
      required: true,
      type: Object,
    },
  },
  computed: {
    services() {
      return this.eligibility?.services || [];
    },
  },
  methods: {
    // Returns `success` if service is eligible and not bypassed
    tagTypeFor(name) {
      const service = this.eligibility[name];
      if (service.isEligible && !service.eligibilityBypassed) return "success";
      return "danger";
    },
  },
};
</script>

<style scoped>
.eligibility-tags {
  align-items: center;
  text-align: justify !important;
}
</style>
